import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Button } from './ui/button';

const CTA = () => {
  return (
    <section className="relative py-24 lg:py-28 overflow-hidden">
      <div className="max-w-6xl mx-auto px-6 lg:px-10">
        <div className="relative rounded-[2.5rem] overflow-hidden border border-[#D4A94F]/25 bg-gradient-to-br from-[#141210] via-[#0d0d0d] to-black p-10 md:p-16 lg:p-20">
          {/* Golden orbs */}
          <div className="absolute -top-32 -right-32 w-96 h-96 rounded-full bg-[#D4A94F]/15 blur-[80px]" />
          <div className="absolute -bottom-32 -left-32 w-96 h-96 rounded-full bg-[#B8892C]/10 blur-[80px]" />

          {/* Decorative circles */}
          <div className="absolute inset-0 opacity-30 pointer-events-none">
            <div className="absolute top-8 right-8 w-24 h-24 rounded-full border border-[#D4A94F]/20" />
            <div className="absolute bottom-8 left-8 w-32 h-32 rounded-full border border-[#D4A94F]/15" />
          </div>

          <div className="relative text-center max-w-3xl mx-auto">
            <div className="inline-block px-4 py-1.5 rounded-full border border-[#D4A94F]/30 bg-[#D4A94F]/5 mb-6">
              <span className="text-xs font-medium tracking-widest uppercase text-[#E9C46A]">
                Siap Memulai?
              </span>
            </div>
            <h2 className="text-white font-bold text-4xl md:text-5xl lg:text-6xl leading-[1.1] tracking-tight mb-6">
              Waktunya Musikmu
              <br />
              <span className="gold-gradient-text">Didengar Dunia</span>
            </h2>
            <p className="text-neutral-300 text-lg mb-10 max-w-2xl mx-auto">
              Bergabung dengan 1.200+ artis Indonesia yang sudah merilis musik
              mereka ke platform digital global bersama Werdi Media.
            </p>
            <div className="flex flex-wrap gap-4 justify-center">
              <Button
                asChild
                className="h-14 px-8 rounded-full bg-gradient-to-r from-[#E9C46A] to-[#D4A94F] text-black font-semibold text-base btn-transition gold-shimmer hover:shadow-[0_15px_50px_-10px_rgba(212,169,79,0.7)]"
              >
                <Link to="/rilis-musik">
                  Rilis Musik Sekarang
                  <ArrowRight className="ml-2 w-4 h-4" />
                </Link>
              </Button>
              <Button
                variant="outline"
                className="h-14 px-8 rounded-full bg-white/5 border border-white/15 hover:border-[#D4A94F] hover:bg-[#D4A94F]/10 text-white font-semibold btn-transition"
              >
                <Link to="/kontak">Konsultasi Gratis</Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;
